import { observer } from 'mobx-react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { TodoTaskCard } from '../components/cards/todoTaskCard';
import { useEffect, useState } from 'react';
import { useLoanStore } from '@roc/feature-loans';
import { LoanProcess } from '@roc/feature-utils';
import { DocumentForms, useDocumentStore } from '@roc/feature-documents';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useHistory } from 'react-router';
import { useLoanFlags } from '../hooks/useLoanFlags';
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '@media (max-width: 992px)': {
      marginLeft: '-6px',
    },
  },
}));
export const UnderwritingTasksTab = observer(() => {
  const { documentStore } = useDocumentStore();
  const { loanStore } = useLoanStore();
  const { loanDetails } = loanStore;
  const loanId = loanDetails?.loanId;
  const { loanTodosStore } = documentStore;
  const currentForm = documentStore.documentFormStore.currentForm;
  const loanProcess = LoanProcess.UNDERWRITING;
  const classes = useStyles();
  const { loanRoutesConfig } = useLoanRoutes();
  const { push } = useHistory();
  const { showUnderwritingAndClosingTab } = useLoanFlags();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (showUnderwritingAndClosingTab) {
      push(loanRoutesConfig.loans(loanId).children.todos.url);
    }
    loanTodosStore.setShowOnlyPending(false);
    loanTodosStore.setPrioritiesFilter([]);
    setInitialized(true);
  }, []);

  const todos =
    documentStore.loanTodosStore.todosByLoanProcess[loanProcess] ?? [];

  useEffect(() => {
    documentStore.loanTodosStore.fetchTodos(loanId, LoanProcess.UNDERWRITING);
  }, [loanId]);

  useEffect(() => {
    if (!currentForm && todos.length > 0) {
      loanTodosStore.fetchTodos(loanId, loanProcess);
    }
  }, [loanId, currentForm]);

  return (
    <>
      {initialized &&
        <Grid item xs={12} className={classes.container}>
          <TodoTaskCard
            loanProcess={loanProcess}
            showFilter
            showSectionActions={true}
            showFileName={true}
            showDownloadAll
            todos={todos}
            showActions={true}
            loanId={loanId}
          />
        </Grid>
      }
      <DocumentForms loanId={loanDetails.loanId} />
    </>
  );
});
